import CustomVideoPlayer from '../../CustomVideoPlayer'
import ImageBox from './components/ImageBox'
import StorybookEmbed from './components/storyBookEmbed'

export default {CustomVideoPlayer, ImageBox, StorybookEmbed}
